import { SERVICES } from "../../data/services";
import { SERVICE_AREAS } from "../../data/company";

/**
 * Single source of truth for site navigation. Header, mobile menu and footer
 * all read from here, so a new service or city page can't end up reachable
 * from one and not the others.
 *
 * Blogs are deliberately not in the primary nav. The posts are useful but
 * they're not what a homeowner comparing contractors is looking for, and five
 * primary items plus a CTA is already the practical limit before a nav starts
 * reading as a sitemap. They stay linked from the footer.
 */

export const PRIMARY_NAV = [
  {
    label: "Services",
    to: "/services",
    // Rendered as a mega panel on desktop, an accordion on mobile.
    panel: {
      intro: "Nine trades, mostly self-performed — which is why the finished work lines up.",
      items: SERVICES.map((service) => ({
        label: service.title,
        to: `/services/${service.slug}`,
        description: service.summary,
      })),
      footerLink: { label: "All services", to: "/services" },
    },
  },
  { label: "Projects", to: "/projects" },
  { label: "About", to: "/about" },
  {
    label: "Service Areas",
    to: "/service-areas",
    panel: {
      intro: "Based in Pickering. Most of our work sits in the western end of Durham Region.",
      items: SERVICE_AREAS.map((area) => ({
        label: area.name,
        to: `/${area.slug}`,
      })),
      footerLink: { label: "All service areas", to: "/service-areas" },
    },
  },
  { label: "Contact", to: "/contact" },
];

export const FOOTER_NAV = {
  company: [
    { label: "About", to: "/about" },
    { label: "Projects", to: "/projects" },
    { label: "Services", to: "/services" },
    { label: "Journal", to: "/blogs" },
    { label: "Contact", to: "/contact" },
  ],
  services: SERVICES.map((service) => ({
    label: service.title,
    to: `/services/${service.slug}`,
  })),
  areas: [
    ...SERVICE_AREAS.map((area) => ({ label: area.name, to: `/${area.slug}` })),
    { label: "All service areas", to: "/service-areas" },
  ],
};
